import React from "react";
import { DateTime } from "luxon";

import useCalendarPreferences from "app/utils/hooks/useCalendarPreferences";
import { formatTime } from "app/utils/luxonFormats";
import styles from "./styles.module.scss";

type PropsDef = {
  event: any;
  timeText: string;
  timeZone?: string;
};

export default function ScheduleBlock(props: PropsDef) {
  const { durationInMinutes, eventColor } = props.event.extendedProps;

  const { preferences } = useCalendarPreferences();
  const startTimeString = formatTime(
    DateTime.fromJSDate(props.event.start, { zone: props.timeZone }),
    preferences.timeFormat,
  );

  const leftBarStyle = eventColor ? { backgroundColor: eventColor } : {};

  return (
    <div
      className={`${styles.event_container} ${durationInMinutes < 30 ? styles.small_event : ''}`}
      data-testid="calendar-event-block"
    >
      <div
        className={styles.schedule_block_bar}
        style={leftBarStyle}
      />
      <div className={styles.schedule_block_event}>
        <div className={styles.event_title}>{props.event.title}</div>
        <div className={styles.event_time}>{startTimeString}</div>
      </div>
    </div>
  );
}
